import { BackButtonListener } from "nx-components/BackButtonResponder";
import enqueueIn from "nx-components/utils/enqueueIn";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store from "nexia_mobile/flux_like/store";
import Platform from "nexia_mobile/platform";
import LocalSettings from "nexia_mobile/models/local_settings";
import { showConfirmationDialog } from "nexia_mobile/components/Dialogs/ConfirmationDialog";
import { history, clearHistoryAndVirtualPopTo } from "nexia_mobile/history";

Dispatch.on("OBTAIN_PUSH_NOTIFICATION_TOKEN", () => {
  LocalSettings.obtainPushNotificationToken();
});

let backButtonEnabled = true;
Dispatch.on("START_LISTENING_TO_PLATFORM_BACK_BUTTON", () => {
  const listener = BackButtonListener.getSingleton();

  backButtonEnabled = true;
  Dispatch.listenTo(Platform, Platform.Event.BACK_BUTTON, () => {
    if (!backButtonEnabled) {
      return;
    }
    backButtonEnabled = false;
    enqueueIn(() => (backButtonEnabled = true), 500);

    listener.processBackButtonPress();
  });

  listener.registerResponderCallback(() => {
    const exitLocations = new Set([
      "/welcome",
      "/pin-entry/create",
      "/pin-entry/validate",
      "/reauth",
      "/app/home",
    ]);
    // If nothing else has handled this back button press, then if we are in an
    // exit location, we should exit the app. Otherwise, we should go to
    // the dashboard (if we are logged in).
    if (exitLocations.has(history.location.pathname)) {
      if (Store.appState.inDemoMode) {
        Dispatch("APP_LOG_OUT");
      } else {
        Platform.exitApp();
      }
      return { handled: true };
    } else if (Store.appState.userAuthenticated) {
      clearHistoryAndVirtualPopTo("/app/home");
      return { handled: true };
    } else {
      return { handled: false };
    }
  });
});

Dispatch.on("START_LISTENING_TO_PLATFORM_EVENTS", () => {
  Dispatch.listenTo(Platform, Platform.Event.BANNER_MESSAGE, (message) => {
    Dispatch("SHOW_TOAST", message);
  });

  Dispatch.listenTo(Platform, Platform.Event.CONFIRM, (message, onConfirm) => {
    showConfirmationDialog({
      message,
      onConfirm,
    });
  });
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/platform.js